<template>
  <div style="background-color:white">
    <el-divider></el-divider>
    <h1>检定录入</h1>
    <el-form ref="form" :rules="rules" :model="form" label-width="100px">
      <el-row :gutter="20">
        <el-col :span="7" :push="1">
          <el-form-item :label="lable.jdsb">
            <el-input v-model="form.jdsb" :readonly="true" placeholder="请选择资产"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1">
          <DC :transferValue="transferValue" :personInfo="0" :show="show"></DC>
        </el-col>
        <el-col :span="8" :push="3"><el-form-item label="规格型号">
            <el-input v-model="form.sbxh" :readonly="true" placeholder="请选择资产"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item label="生产厂家">
            <el-input v-model="form.sccj" :readonly="true" placeholder="请选择资产"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1">
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3">
          <el-form-item label="出厂编号">
            <el-input v-model="form.ccbh" :readonly="true" placeholder="请选择资产"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item prop="checkCompany" label="检定单位">
            <el-input v-model="form.checkCompany" placeholder="请输入检定单位"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1">
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3">
          <el-form-item prop="checkCertificate" :label="lable.checkCertificate">
            <el-input v-model="form.checkCertificate" :placeholder="'请输入' + lable.checkCertificate"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item :label="lable.checkTime" prop="checkTime">
            <div class="block">
              <el-date-picker v-model="form.checkTime" type="date" value-format="yyyy-MM-dd" style="width:100%"
                :placeholder="'请选择' + lable.checkTime">
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1">
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3"><el-form-item label="检定备注">
            <el-input v-model="form.remarks" type="textarea" placeholder="请输入检定备注"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="9" :push="1">
          <el-form-item :label="lable.jg" prop="jg" v-if="form.zjqr">
            <el-select v-model="form.jg" placeholder="请选择" style="width:100%">
              <el-option v-for="item in jgOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="2" :push="1"> </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="8" :push="3"><el-form-item label="录入并确认">
            <el-switch v-model="form.zjqr"></el-switch>
            <span style="color:#909399;font-size:12px"> 关闭后保存为待确认记录</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="19" :push="1">
          <el-form-item label="附件列表" align="left">
            <el-table :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
              :cell-style="{ textAlign: 'center' }" ref="multipleTable" :data="fileData" tooltip-effect="dark"
              style="width: 100%" :border="true" height="290">
              <el-table-column prop="id" v-if="false"> </el-table-column>
              <el-table-column label="附件序号" type="index" width="100">
              </el-table-column>
              <el-table-column prop="createTime" label="时间" width="200">
              </el-table-column>
              <el-table-column prop="enclosureName" label="文件名称" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="fileDescribe" label="资料备注" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="id" label="操作" show-overflow-tooltip>
                <template slot="header" slot-scope="scope">
                  <el-button class="flter-item" type="primary" @click="handleCreate">添加</el-button>
                </template>
                <template slot-scope="scope">
                  <el-button @click="yulan(scope.row)" type="text" size="small">在线预览</el-button>
                  <el-button @click="DFile(scope.row)" type="text" size="small">删除</el-button>
                  <el-button @click="updateFile(scope.row)" type="text" size="small">修改</el-button>

                  <el-button @click="downloading(scope.row)" type="text" size="small">下载</el-button>

                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="2" :push="8">
          <el-form-item>
            <el-button type="primary" @click="submitCheck" v-preventReClick>确认</el-button>
          </el-form-item></el-col>
        <el-col :span="2" :push="10">
          <el-form-item>
            <el-button type="success" @click="cancel">返回</el-button>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!---------------------------------------------------附件资料修改 ---------------------------------------------------------->
    <el-dialog :visible.sync="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false"
      :append-to-body="true" title="附件资料上传" style="width: 60% !important;margin-left:350px;">
      <el-form ref="formTwo" :model="formTwo" label-width="80px" style="width: 80%; margin-left:30px;">
        <el-form-item label="文件名称" prop="fileName">
          <el-select v-model="formTwo.fileName" placeholder="请选择" style="width:100%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资料备注" prop="fileDesc">
          <el-input type="textarea" v-model="formTwo.fileDesc"></el-input>
        </el-form-item>
        <el-form-item label="id" prop="id" v-if="false">
          <el-input type="textarea" v-model="formTwo.id"></el-input>
        </el-form-item>
        <el-form-item label="文件上传">
          <el-upload class="upload" ref="upload" action="string" :file-list="fileList" :auto-upload="false"
            accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx" :http-request="uploadFile" :on-change="handleChange"
            :on-preview="handlePreview" :on-remove="handleRemove" multiple="multiple">
            <el-button slot="trigger" size="small" type="primary" @click="delFile">选取文件</el-button>
          </el-upload>
          <span>上传文件只能是jpg,png,npg,doc,docx,pdf格式</span>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit" v-preventReClick>上传</el-button>
          <el-button @click="cancelSubmit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :visible.sync="updateDialog" :close-on-click-modal="false" :close-on-press-escape="false"
      :append-to-body="true" title="附件资料修改" style="width: 60% !important;margin-left:350px;">
      <el-form ref="formTwo" :model="fileForm" label-width="80px" style="width: 80%; margin-left:30px;">
        <el-form-item label="文件名称" prop="enclosureName">
          <el-select v-model="fileForm.enclosureName" placeholder="请选择" style="width:100%">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="资料备注" prop="fileDescribe">
          <el-input type="textarea" v-model="fileForm.fileDescribe"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="clickUpdate" v-preventReClick>修改</el-button>
          <el-button @click="cancelSubmit">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :title="previewTitle" :visible.sync="docxdialog" style="margin-top:-50px" width="63%">
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>

<script>
import {
  uploadFlie,
  findByidFile,
  insertCheck,
  delCheckFile,
  findByModule,
  updateCheckEnclosure
} from "../../api/api";
import DeviceWarningVue from '../../components/common/DeviceWarning.vue';
import FilePreview from '../../components/preview/FilePreview.vue'
import Select from '../allocation/Select.vue';

export default {
  name: "AddVenfication",
  components: {
    "DC": DeviceWarningVue,
    "FilePreview": FilePreview,
    Select,
  },
  data() {

    return {
      options: [{
        value: "检定证书",
        label: "检定证书"
      }, {
        value: "设备图片",
        lable: "设备图片"
      }, {
        value: "确认表",
        lable: "确认表"
      }
      ],
      updateDialog: false,
      fileForm: {},
      show: false,
      form: {
        zcmc: "",
        sbxh: "",
        sccj: "",
        ccbh: "",
        checkCompany: "",
        checkCertificate: "",
        checkTime: "",
        remarks: "",
        ssdw: "",
        glbh: "",
        remarks: "",
        deviceId: "",
        jg: "",
        zjqr: true,
        delivery: false
      },
      jgOptions: [
        { value: "符合要求", label: "符合要求" },
        { value: "部分符合要求", label: "部分符合要求" },
        { value: "不符合要求", label: "不符合要求" }
      ],
      lable: {},
      docxdialog: false,
      previewTitle: '',
      formTwo: {
        fileName: "",
        fileDesc: "",
        id: ""
      },
      fileList: [],
      dialogFormVisible: false,
      //文件上传
      fileData: [],
      // 不支持多选
      multiple: false,
      formData: "",
      rules: {
        // checkCompany: [
        //   { required: true, message: "请输入检定单位", trigger: "blur" }
        // ],
        checkCertificate: [
          { required: true, message: "请输入检定证书号", trigger: "blur" }
        ],
        jg: [
          { required: true, message: "选择检定结果", trigger: "blur" }
        ],
        checkTime: [
          {
            type: "string",
            required: true,
            message: "请选择日期",
            trigger: "blur"
          }
        ],
        remarks: [{ required: true, message: "请输入备注", trigger: "blur" }],
      },

    };
  },

  methods: {
    updateFile(row) {
      // console.log(row)
      this.fileForm = _.cloneDeep(row) ;
      this.updateDialog = true
    },
    clickUpdate() {
      var parmar = {
        id: this.fileForm.id,
        enclosureName: this.fileForm.enclosureName,
        describe: this.fileForm.fileDescribe
      }
      updateCheckEnclosure(parmar).then(datas => {
        let { data, message, status } = datas
        if (status == 200) {
          this.cancelSubmit();
          this.selectFile(this.form.id);
          this.$message.success(message)
        } else {
          this.$message.error(message)
        }
      })
    },
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.enclosureName);
    },
    yulan(row) {
      if (row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpg' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'png' || row.path.substring(row.path.lastIndexOf(".") + 1) == 'jpeg') {
        this.previewTitle = "图片预览"
      } else {
        this.previewTitle = "文件预览"
      }
      this.docxdialog = true
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path)
      })
      // this.downloadUtil.preview(row.path)
    },
    transferValue(outData) {
      this.form.jdsb = outData.zcmc;
      this.form.deviceId = outData.id;
      this.form.sbxh = outData.sbxh;
      this.form.sccj = outData.sccj;
      this.form.ccbh = outData.ccbh;
      this.form.glbh = outData.glbh;
    },
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        let formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("checkId", this.form.id);
        formData.append("enclosureName", this.formTwo.fileName);
        formData.append("describe", this.formTwo.fileDesc);
        var userinfo = JSON.parse(localStorage.getItem("user"))
        formData.append("userId", userinfo.userId);
        uploadFlie(formData).then(datas => {
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.selectFile(this.form.id);
            this.fileList = [];
            this.dialogFormVisible = false;
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      }
    },
    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {
    },
    // 点击文件
    handlePreview(file) {
    },

    //根据id查找附件
    selectFile(row) {
      findByidFile(row).then(datas => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
          // debugger
        }
      });
    },

    DFile(row) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delCheckFile(row.id).then(datas => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.selectFile(this.form.deviceId);
            this.$message({
              message: message,
              type: "success"
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    submitCheck() {
      var userinfo = JSON.parse(localStorage.getItem("user"))
      this.form.userId = userinfo.userId
      this.form.jdlx = 0
      // 未开启"录入并确认"时结果留空，由确认人核对证书后选择
      if (!this.form.zjqr) {
        this.form.jg = "";
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          console.log(this.form)
          console.log("来了")

          insertCheck(this.form).then(datas => {
            console.log(datas)
            // debugger
            let { status, message, data } = datas;
            if (status == 400) {
              this.$message({
                message: message,
                type: "error"
              });
            } else if (status == 200) {
              this.$message({
                message: data,
                type: "success"
              });
              let val = {
                path: "/verification",
                name: "检定信息"
              };
              this.$router.push({
                path: "verification"
              });
              this.$store.commit("pushtags", val);
              // debugger
            } else {
              this.$message({
                message: "请求错误",
                type: "error"
              });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    cancel() {
      this.$router.push({
        path: "warning"
      });
    },
    cancelSubmit() {
      this.dialogFormVisible = false;
      this.updateDialog = false;
    },
    handleCreate() {
      this.formTwo.fileDesc = "";
      this.formTwo.fileName = "";
      this.formTwo.id = this.form.id;
      this.dialogFormVisible = true;
    },
    findLable() {
      findByModule("设备检定").then(datas => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },
  },
  created() {
    // 2019-07-09 19:44:01
    this.findLable();
    this.$set(this.form, `checkTime`, this.timeUtil.timeFormat(new Date()))
    var arrAfter = JSON.parse(sessionStorage.getItem("data"));
    sessionStorage.removeItem("data")
    this.form.id = Date.now();
    if (arrAfter != null) {
      // this.selectFile(arrAfter.id);
      this.form.deviceId = arrAfter.id;
      this.form.ccbh = arrAfter.ccbh;
      this.form.sbxh = arrAfter.sbxh;
      this.form.sccj = arrAfter.sccj;
      this.form.jdsb = arrAfter.zcmc;
      this.form.ssdw = arrAfter.ssdw;
      this.form.glbh = arrAfter.glbh;
      if (arrAfter.show) {
        this.show = true;
      }
    }

  }
};
</script>

<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/verification/AddVenfication.vue